import { Injectable } from '@angular/core';
import { RemoteHttpService } from 'src/remote-http';
import { ClubFlightService } from '../club-flight-service/club-flight-service';
import { Custom_RequestMethod } from '../common-service';
import { Observable } from 'rxjs';
import { ContentType, RemoteRequest } from 'src/remote-request';
import * as global from '../../globals';
import { Advertisement, PartnerProgramMembershipApplication, PlayerDiscountProgram } from 'src/data/mygolf.data';
import { JsonService } from 'src/json-util';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class HandicapMembershipService {
    constructor(public http: RemoteHttpService,
        public flightService: ClubFlightService,
        public requestMethod: Custom_RequestMethod,
    ) {
    }

    /**
     * Get Ads to display in general area.
     * @returns {Observable<Advertisement[]>}
     */
    public getAdToDisplay(): Observable<Advertisement[]> {
        let url = global.ServerUrls.getAdsForDisplay;
        let request = new RemoteRequest(url, this.requestMethod.get,
            ContentType.URL_ENCODED_FORM_DATA, {
            portalOrApp: 'app'
        });
        return this._getAds(request);
    }

    /**
     * Get the list of ads to display for a given specific competition
     * @param {number} competitionId The ID of the competition
     * @returns {Observable<Advertisement[]>}
     */
    public getCompetitionAds(competitionId: number): Observable<Advertisement[]> {
        let url = global.ServerUrls.getAdsForDisplay;
        let request = new RemoteRequest(url, this.requestMethod.get,
            ContentType.URL_ENCODED_FORM_DATA, {
            portalOrApp: 'app',
            competitionId: competitionId
        });
        return this._getAds(request);
    }

    // private _getAds(request: RemoteRequest): Observable<Advertisement[]> {
    //     return this.http.execute(request)
    //         .pipe(map((resp: Response) => {
    //             let ads: Advertisement[] = resp.json();
    //             if (ads && ads.length)
    //                 ads.forEach(ad => {
    //                     JsonService.deriveFullUrl(ad, 'imageUrl');
    //                 });
    //             return ads;
    //         }));
    // }
    private _getAds(request: RemoteRequest): Observable<Advertisement[]> {
        return this.http.execute(request).pipe(map((result: any) => {
            let ads: Advertisement[] = result;
            if (ads && ads.length)
                ads.forEach(ad => {
                    JsonService.deriveFullUrl(ad, 'imageUrl');
                });
            return ads;
        }));
    }

    public getMembershipApplications(params) {
        return new Promise((resolve, reject) => {
            let _params = params;
            let _playerId;
            if (params['playerId']) _playerId = params['playerId'];
            this.flightService.getPlayerDiscountPrograms(_playerId)
                .subscribe((data) => {

                    if (data) {
                        data = data.filter((program: PlayerDiscountProgram) => {
                            return program.discountProgram.includesHandicap
                        })
                        if (data && data.length > 0) {
                            let _applications = [];
                            data.forEach((program: PlayerDiscountProgram) => {
                                _applications.push(program.applicationRenewed);
                            })

                            _applications.map((app: PartnerProgramMembershipApplication) => {
                                return app && app.applicationDate
                            }).sort((a, b) => {
                                if (a > b) return -1
                                else if (a < b) return 1;
                                else return 0;
                            })
                            resolve({
                                status: 'success',
                                data: _applications
                            })

                        } else {
                            resolve({
                                status: 'success',
                                data: null
                            })
                        }
                    }
                }, (error) => {
                    reject({
                        status: 'failed',
                        data: null,
                        error: error
                    })
                });
            // this.flightService.listPartnerApplication(_params)
            // .subscribe((partnerApplications)=>{
            //     if(partnerApplications) {
            //         resolve({
            //             status: 'success',
            //             data: partnerApplications
            //         })
            //     } else {
            //         resolve({
            //             status: 'success',
            //             data: null
            //         })
            //     }
            // }, (error)=>{
            //     reject({
            //         status: 'failed',
            //         data: null,
            //         error: error
            //     })
            // })
        })
    }

    public getNHSHcp(params) {
        return new Promise((resolve, reject) => {
            let _params = params;
            this.flightService.getPartnerList(_params)
                .subscribe((partners) => {
                    if (partners) {
                        resolve({
                            status: 'success',
                            data: partners
                        })
                    } else {
                        resolve({
                            status: 'success',
                            data: null
                        })
                    }
                }, (error) => {
                    reject({
                        status: 'failed',
                        data: null,
                        error: error
                    })
                })
        })
    }
}
